export const HOUSE_AD_CATEGORY_PARENT_ID = 1032;
export const HOUSE_NUMBER_OF_ROOMS_KEY = 'numberOfRooms';
export const HOUSE_NUMBER_OF_BEDROOMS_KEY = 'numberOfBedrooms';
export const HOUSE_SQUARE_METERS_KEY = 'livingArea';
export const HOUSE_TYPE_KEY = 'typeOfProperty';
export const HOUSE_ENERGY_LABEL_KEY = 'energyLabel';
export const HOUSE_REGION_KEY = 'region';
export const HOUSE_CITY_KEY = 'city';
